import { get } from "../../service/api";

const GetPosPayoutPreview = async (vatMerchantId) => {
  try {
    const response = await get(`/pos/preview/${vatMerchantId}`);
    return response;
  } catch (error) {
    console.error("Error GetPosPayoutPreview:", error);
    throw error;
  }
};

export default GetPosPayoutPreview;
